import React, { useState } from "react";
import PropTypes from "prop-types";
import { HelpModeContext, CredsContext } from "./Contexts";
import TextField from "@mui/material/TextField";
import "./styles/Requirements.css";

function RequirementsSynopsis(props) {
  const [synopsis, setSynopsis] = useState(props.synopsis);

  const handleSynopsisFieldValueChange = (event) => {
    props.handleSynopsisChange(event.target.value);
    setSynopsis(event.target.value);
  };

  if (props.synopsis == "" && synopsis.length > 1) {
    setSynopsis("");
  }
  return (
    <TextField
      required
      id="__reqSynopsis"
      value={synopsis}
      onChange={handleSynopsisFieldValueChange}
      variant="standard"
      label="Synopsis"
      sx={{
        margin: "0px 10px",
        width: "1000px",
      }}
    ></TextField>
  );
}

export default RequirementsSynopsis;

RequirementsSynopsis.propTypes = {
  synopsis: PropTypes.string,
  handleSynopsisChange: PropTypes.func,
};
